import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { ChatsQueryKeys } from "./chatsQueryKeys";
import { getChats, GetChatsParams } from "@/api/chats";

export const useChats = (
  params?: GetChatsParams,
  options: { enabled?: boolean } = {}
) => {
  return useQuery({
    queryKey: [ChatsQueryKeys.Chats, params],
    enabled: options.enabled ?? true,
    placeholderData: keepPreviousData,
    queryFn: ({ signal }) => getChats({ signal, params: params || {} }),
  });
};
